var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('NavBar',{attrs:{"title":_vm.$t('newAdd.Recharge')}}),_vm._l((4),function(item,index){return _c('div',{key:'p'+index,staticClass:"content_p"},[_c('p',[_vm._v(_vm._s(_vm.$t("rechargeDesc.p"+item)))]),_c('br')])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }